import React, { Component } from 'react';
import { createRoot } from 'react-dom/client'
import Question from './Question';
import Timeline from './Timeline';
import "./Quiz.css";

export default class Quiz extends Component {
    constructor(props) {
        super(props);

        this.state = {
            current_question: 0,
            available_questions: [0]
        };

        this.completedQuestion = this.completedQuestion.bind(this);
    }

    completedQuestion() {
        this.setState((state, props) => ({
            current_question: state.current_question + 1,
            available_questions: state.available_questions.
                concat([state.current_question + 1])
        }))
    }

    selectQuestion(index) {
        if (this.state.available_questions.includes(index)) {
            this.setState((state, props) => ({
                current_question: index
            }))
        }
    }

    render() {
        return (
            <div>
                <Timeline count={questions.length}
                          available={this.state.available_questions}
                          current={this.state.current_question}
                          onSelect={this.selectQuestion.bind(this)}/>

                {questions.map((question, index) => (
                    <Question key={question.id}
                              question={question}
                              onComplete={this.completedQuestion}
                              hidden={this.state.current_question !== index}/>
                ))}

                {(this.state.current_question >= questions.length) &&
                    <div className={"narrow-centered"}>
                        <h2>dat waren alle vragen</h2>
                        <p>
                            Klik op de onderstaande knop om je
                            antwoorden op te sturen en te kijken of de boost iets voor jou is.
                        </p>
                        <button type={"submit"} className={"btn"}>
                            bekijk uitkomst
                        </button>
                    </div>
                }
            </div>
        );
    }
}

const container = document.getElementById('quiz')
if (container) {
    const root = createRoot(container)
    root.render(<Quiz />);
}
